import React, { Component } from "react";

export default class About extends Component {
  render() {
    return <div class="content-container">About</div>;
  }
}
